import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { WorkbookUrl } from '../models';

export const useWorkbookUrl = (): WorkbookUrl => {
  const location = useLocation();

  const { category, workbook } =
    useParams<{ category?: string; workbook?: string }>();

  return useMemo(() => {
    const filters = location?.search
      ? new URLSearchParams(location.search)
      : undefined;

    return {
      category,
      workbook,
      filters,
    };
  }, [category, location?.search, workbook]);
};
